import { EventListeners, MinzeElement } from 'minze'
import { Font } from '../../constants'
import { getCardPlaceholder } from '../../modules/utils'

export class LvcFavoriteItem extends MinzeElement {
  attrs = ['data-id', 'data-type', 'data-url', 'data-image-url', 'data-image-alt']

  onLinkClicked = (event: Event) => {
    // @ts-ignore
    if (event.target?.tagName === 'LVC-FAVORITE-BUTTON') event.preventDefault()
  }

  html = () => `
    <div class="favorite-item">
      <a href="${this.dataUrl}" class="favorite-item-link">
        <div class="favorite-item-content">
          <div class="favorite-item-image-wrapper">
            <lvc-image
              src="${this.dataImageUrl || getCardPlaceholder(this.dataType as string)}"
              alt="${this.dataImageAlt}"
              data-image-placeholder="${getCardPlaceholder(this.dataType as string)}"
            ></lvc-image>
            <lvc-favorite-icon-button
              data-id="${this.dataId}"
              data-type="${this.dataType}"
            >
            </lvc-favorite-icon-button>
          </div>
          <div>
            <h4 class="text-style-2lines">
              <slot name="title"></slot>
            </h4>
            <div class="calendar-details">
              <div class="calendar-icon">
                <lvc-calendar-icon></lvc-calendar-icon>
              </div>
              <div>
                <slot name="date"></slot>
              </div>
            </div>
          </div>
        </div>
      </a>
    </div>
  `

  css = () => `
    .favorite-item {
      flex-direction: column;
      justify-content: center;
      align-items: flex-start;
      padding: 0px;
      gap: 16px;
    }
    
    a {
      color: #1e007d;
      font-size: 0.875rem;
      text-decoration: none;
    }
    
    h4 {
      font-weight: ${Font.weight.extraBold};
      font-size: 20px;
      line-height: 120%;
      text-transform: uppercase;
      margin: 16px 0 12px 0;
    }
    
    .calendar-details {
      display: flex;
      align-items: center;
      gap: 4px;
      margin-bottom: 16px;
    }
    
    .calendar-icon lvc-calendar-icon {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 20px;
      height: 20px;
    }
    
    .text-style-2lines {
      display: -webkit-box;
      overflow: hidden;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
    }
    
    .favorite-item-image-wrapper {
      position: relative;
    }

    lvc-favorite-icon-button {
      position: absolute;
      top: 10px;
      right: 10px;
      z-index: 2;
    }
  `

  eventListeners: EventListeners = [['.favorite-item-link', 'click', this.onLinkClicked]]
}
